import { render, staticRenderFns } from "./partake-list.vue?vue&type=template&id=0cb7b114&scoped=true&"
import script from "./partake-list.vue?vue&type=script&lang=js&"
export * from "./partake-list.vue?vue&type=script&lang=js&"
import style0 from "./partake-list.vue?vue&type=style&index=0&id=0cb7b114&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7b114",
  null
  
)

export default component.exports